import axios from 'axios'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useEffect, useRef, useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import classNames from 'classnames'

import { requestFamilies } from '../../actions/familyActions'

import classes from './MembersListLayout.module.scss'
import { requestGetAllStudents, requestGetInvitations } from '../../actions/communitiesActions'
import { deserialize } from '../../utility/serialization'
import Loader from '../common/loader/Loader'
import { PER_PAGE_DEFAULT } from '../../misc/Constants'
import { DEFAULT_SORT_OPTION } from '../../utility/members'


const MembersListLayout = () => {
  const abortController = useRef(null)
  const communityId = useSelector(state => state.user.current_user.communities[0].id)

  // TODO: Refactor using redux (slices) instead of outlet context
  const [loadedStudentsData, setLoadedStudentsData] = useState(null)
  const [loadedFamiliesData, setLoadedFamiliesData] = useState(null)
  const [loadedInvitedData, setLoadedInvitedData] = useState(null)
  const [familiesCount, setFamiliesCount] = useState(null)
  const [studentsCount, setStudentsCount] = useState(null)
  const [, setInvitedCount] = useState(null)

  useEffect(() => {
    abortController.current = new AbortController()

    const actions = [
      requestFamilies(communityId, 1, PER_PAGE_DEFAULT, '', false, abortController.current?.signal),
      requestGetAllStudents({
        communityId,
        page: 1,
        perPage: PER_PAGE_DEFAULT,
        search: '',
        userIds: null,
        sortField: DEFAULT_SORT_OPTION.sortField,
        sortValue: DEFAULT_SORT_OPTION.sortValue,
        signal: abortController.current?.signal,
      }),
      requestGetInvitations({
        communityId,
        search: '',
        signal: abortController.current?.signal,
      }),
    ]

    Promise.all(actions)
      .then(([familiesRes, studentsRes, loadedRes]) => {
        const familiesData = deserialize(familiesRes.data)
        const studentsData = deserialize(studentsRes.data)
        const invitedData = deserialize(loadedRes.data)

        setLoadedFamiliesData(familiesData)
        setLoadedStudentsData(studentsData)
        setLoadedInvitedData(invitedData)
        setFamiliesCount(familiesData.meta.pagination.totalCount)
        setStudentsCount(studentsData.meta.pagination.totalCount)
        setInvitedCount(studentsData.invitations?.length || 0)
      })
      .catch((res) => {
        if (!axios.isCancel(res)) {
          toast.error('Something went wrong. Please try again.', { position: toast.POSITION.TOP_RIGHT })
        }
      })

    return () => abortController.current.abort()
  }, [communityId])

  const isMembersDataLoaded = !!loadedFamiliesData && !!loadedStudentsData && !!loadedInvitedData

  return (
    <section className={classes.membersList}>
      <div className={classes.subHeader}>
        <nav>
          <NavLink to='/members/students'>
            {({ isActive }) => (
              <button className={classNames('subHeaderTab', { active: isActive })}>
                Students
                <span className={classNames(classes.revealWrapper, { [classes.isLoaded]: !!studentsCount })}>
                  <span className={classes.revealInner}>({studentsCount})</span>
                </span>
              </button>
            )}
          </NavLink>
          <NavLink to='/members/families'>
            {({ isActive }) => (
              <button className={classNames('subHeaderTab', { active: isActive })}>
                Families
                <span className={classNames(classes.revealWrapper, { [classes.isLoaded]: !!familiesCount })}>
                  <span className={classes.revealInner}>({familiesCount})</span>
                </span>
              </button>
            )}
          </NavLink>
          {/*<NavLink to='/members/invited'>*/}
          {/*  {({ isActive }) => (*/}
          {/*    <button className={classNames('subHeaderTab', { active: isActive })}>*/}
          {/*      Invited*/}
          {/*      <span className={classNames(classes.revealWrapper, { [classes.isLoaded]: !!invitedCount })}>*/}
          {/*        <span className={classes.revealInner}>({invitedCount})</span>*/}
          {/*      </span>*/}
          {/*    </button>*/}
          {/*  )}*/}
          {/*</NavLink>*/}
        </nav>
      </div>
      {isMembersDataLoaded ? (
        <Outlet context={{ loadedStudentsData, loadedFamiliesData, loadedInvitedData }} />
      ) : (
        <main className={classes.wrapper}>
          <div className='h-100 d-flex align-items-center justify-content-center'>
            <Loader>Loading Members</Loader>
          </div>
        </main>
      )}
    </section>
  )
}

export default MembersListLayout
